export const userActivationCodeStateKeys = {
  isLoading: 'isLoading',
  workflowState: 'codeStatus',
  userApplicationIdForRedirect: 'userApplicationIdForRedirect' 
};

export const userActivationWorkflowState = {
  codeIsVerified: 2,
  codeIsInvalid: 3,
  codeIsAlreadyUsed: 4,
  codeSentToActivate: 5,
  userIsActivated: 6
};


// WEBPACK FOOTER //
// ./src/constants/user-activation.js